import { createChunkRecovery } from 'shared-components';

import { reloadPage } from '@helpers/window';
import { reportDatadogError } from '@services/datadog';

const { recoverFromChunkError } = createChunkRecovery({
  app: 'webadmin',
  buildVersion: process.env.DD_VERSION as string | undefined,
  reportError: reportDatadogError,
  reload: reloadPage,
});

export { recoverFromChunkError };
